import styled from 'styled-components';
import Image from 'next/image';
import RichText from '@madebyconnor/rich-text-to-jsx';

// interface Items {
//   text: string;
//   href: string;
// }

interface SolutionsSectionProps {
  title: string;
  description?: any;
  solutions: any;
}

interface StyledItemProps {
  color: any;
  textColor: any;
  hoverColor: any;
}

enum hoverColor {
  'Pale Navy' = '#CBD0DA',
  'Dark Moderate Blue' = '#2A457E',
  'White Smoke' = '#E7EAF1',
}

enum textColor {
  'Pale Navy' = '#262626',
  'Dark Moderate Blue' = '#fff',
  'White Smoke' = '#262626',
}

const SolutionsSection: React.FC<SolutionsSectionProps> = ({ title, description, solutions }) => {
  console.log('solutions', solutions);
  return (
    <SectionContainer aria-label="Solutions Section">
      <ContentContainer>
        <TextBlock aria-label="Solutions Text">
          <h2>{title}</h2>
          <RichText richText={description.json} />
        </TextBlock>
        <ItemsList aria-label="Items List">
          {solutions.items.map((solution) => (
            <Item
              key={solution.sys.id}
              color={solution.backgroundColor.value}
              textColor={textColor[solution.backgroundColor.name]}
              hoverColor={hoverColor[solution.backgroundColor.name]}
            >
              <Image
                src={solution.logo.url}
                alt={solution.logo.title}
                layout="intrinsic"
                width={solution.logo.width}
                height={solution.logo.height}
              />
              <RichText richText={solution.description.json} />
            </Item>
          ))}
        </ItemsList>
      </ContentContainer>
    </SectionContainer>
  );
};

const ContentContainer = styled.section`
  max-width: 1350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  column-gap: 200px;
`;

const SectionContainer = styled.section`
  justify-content: space-between;
  align-items: center;
  background-color: #fffdf8;
  padding: 85px 40px 100px;
  background-image: url('/images/wave-bg.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
`;

const TextBlock = styled.div`
  max-width: 50%;
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 645px;

  h2 {
    font-size: 1.5rem;
    font-family: 'alliance_no.2bold';
    font-weight: 700;
    font-size: 60px;
    line-height: 79.2px;
    text-align: center;
    margin: 0 0 24px 0;
  }

  p {
    margin: 40px 0;
    font-family: 'Alliance No.2';
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    margin-top: 0px;

    span {
      font-family: 'alliance_no.2bold';
    }
  }
`;

const ItemsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: center;
`;

const Item = styled.div<StyledItemProps>`
  background-color: ${({ color }) => color};
  color: ${({ textColor }) => textColor};
  border-radius: 50px 1px 50px 1px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  align-items: center;
  padding: 40px 36px 44px 36px;
  width: 423px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: all 0.3s ease-in;

  &:hover {
    filter: drop-shadow(4px 8px 8px rgba(0, 0, 0, 0.5));
    transition: all 0.3s ease-in;
    transform: scale(1.02);
    cursor: pointer;
    background-color: ${({ hoverColor }) => hoverColor};
  }

  svg {
    margin-right: 10px;
  }

  a {
    font-family: 'Alliance No.2';
    font-size: 1.2rem;
    color: #333;
    text-decoration: none;
  }
`;

export default SolutionsSection;
